const EVIDON_CONSENT_COOKIE = '_evidon_consent_cookie';
const EVIDON_GDPR_CONSENT_COOKIE = '_evidon_gdpr_consent_cookie';
const EVIDON_SUPPRESS_NOTIFICATION_COOKIE =
  '_evidon_suppress_notification_cookie';
const EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE =
  '_evidon_suppress_gdpr_notification_cookie';
const EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS = 365;
const EVIDON_PREFERENCES_ACCEPT_BTN_ID = 'evidon-prefdiag-accept';

export {
  EVIDON_CONSENT_COOKIE,
  EVIDON_GDPR_CONSENT_COOKIE,
  EVIDON_SUPPRESS_NOTIFICATION_COOKIE,
  EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE,
  EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
  EVIDON_PREFERENCES_ACCEPT_BTN_ID,
};
